module.exports = __webpack_public_path__ + "21117de3101bdf02bc96b216015f3fbc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/greetings/fly.png
// module id = 3412
// module chunks = 0